import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { TextAreaProps } from '@/formBuilder/node.types'
import React from 'react'
import { useState } from 'react'

type PropTypes = {
  node: TextAreaProps
  handleChange: (key: string, value: string) => void
  className?: string
}
export function TextareaCmp(props: PropTypes) {
  const { node, handleChange, className } = props
  const [value, setValue] = useState(node?.value)

  const handleTextAreaChange = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    const textarevalue = event.target.value
    handleChange(node?.fieldName, textarevalue)
    setValue(event.target.value)
  }

  React.useEffect(() => {
    setValue(node?.value)
  }, [node?.value])

  return (
    <div className='grid w-full gap-1.5'>
      <Label
        htmlFor={node?.id}
        className='text-primary-foreground font-normal text-base'
      >
        {node?.label}
      </Label>
      <Textarea
        data-testid={`${node.id}-textarea`}
        value={value}
        placeholder={node?.placeholder}
        id={node?.id}
        name={node?.fieldName}
        rows={node?.rows}
        disabled={node?.disabled}
        readOnly={node?.readOnly}
        onChange={handleTextAreaChange}
        className={className}
      />
    </div>
  )
}
